
/// <amd-module name="Search/Shared/Components/ShowMoreRow/ShowMoreRow.Props" />
export interface ShowMoreRowProps {
    needShowMore: boolean;

    itemsLoading: boolean;

    className: string;

    onClick: () => void;
}
